import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';
import { z } from 'zod';

import { requireStartAuthSession } from '../auth/require-start-auth-session.ts';
import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';

const GetInstrumentOwnershipPageDataSchema = z.object({
	ticker: z.string().optional(),
});

export const getInstrumentOwnershipPageData = createServerFn({ method: 'GET' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.session'],
			relatesTo: 'instrument.ownership',
		}),
	])
	.inputValidator(GetInstrumentOwnershipPageDataSchema)
	.handler(async ({ data }) => {
		const request = getRequest();
		await requireStartAuthSession({ request });

		if (!data.ticker) {
			return {
				ownershipData: false,
			};
		}

		return {
			ownershipData: false,
		};
	});
